(() => {
  if (customElements.get('cf-restock')) return;
  class RestockDialog extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.options = this.form.elements.variant;
      this.email = this.form.elements.email;
      this.button = this.form.querySelector('[type="submit"]');
      this.status = this.querySelector('[data-cf-restock-status]');
      this.strings = JSON.parse(this.querySelector('[data-cf-restock-strings]').textContent);
      this.label = this.button.textContent;
      this.onOpen = event => {
        const trigger = event.target.closest('[data-cf-restock-open], [data-cf-notify-product]');
        if (!trigger || trigger.disabled) return;
        const card = trigger.closest('cf-restock-card');
        let product;
        let selected;
        if (card) {
          product = JSON.parse(card.querySelector('[data-cf-restock-product]').textContent);
        } else {
          const controller = Array.from(document.querySelectorAll('cf-product-availability')).find(node => node.dataset.cfForm === trigger.dataset.cfNotifyForm);
          if (!controller || controller.pending || controller.invalidChoice || controller.variant?.state !== 'unavailable') return;
          product = { title: controller.data.title, variants: controller.data.variants.filter(variant => variant.state === 'unavailable') };
          selected = controller.variant.id;
        }
        if (!product?.variants?.length) return;
        event.preventDefault();
        this.request?.abort();
        this.request = null;
        this.form.removeAttribute('aria-busy');
        this.opener = trigger;
        this.querySelector('[data-cf-restock-title]').textContent = product.title;
        this.options.replaceChildren(...product.variants.map(variant => new Option(variant.title === 'Default Title' ? product.title : variant.title, String(variant.id))));
        if (selected) this.options.value = String(selected);
        this.querySelector('[data-cf-restock-options]').hidden = product.variants.length === 1;
        this.form.hidden = false;
        this.status.hidden = true;
        this.status.dataset.error = 'false';
        this.button.disabled = false;
        this.button.textContent = this.label;
        this.dialog.showModal();
        document.body.classList.add('cf-restock-open');
        this.email.focus();
      };
      this.onClose = () => {
        document.body.classList.remove('cf-restock-open');
        this.opener?.focus({ preventScroll: true });
      };
      this.onSubmit = event => this.submit(event);
      this.onClick = event => {
        if (event.target.closest('[data-cf-restock-close]') || event.target === this.dialog) this.dialog.close();
      };
      document.addEventListener('click', this.onOpen);
      this.addEventListener('click', this.onClick);
      this.dialog.addEventListener('close', this.onClose);
      this.form.addEventListener('submit', this.onSubmit);
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.onOpen);
      this.removeEventListener('click', this.onClick);
      this.dialog?.removeEventListener('close', this.onClose);
      this.form?.removeEventListener('submit', this.onSubmit);
      this.request?.abort();
      document.body.classList.remove('cf-restock-open');
      this.initialized = false;
    }
    message(key, error) {
      this.status.textContent = this.strings[key];
      this.status.dataset.error = String(error);
      this.status.hidden = false;
    }
    async submit(event) {
      event.preventDefault();
      if (this.button.disabled || !this.form.reportValidity()) return;
      const site = this.dataset.siteId?.trim();
      if (!/^[A-Za-z0-9]{6}$/.test(site || '')) { this.message('configuration', true); return; }
      const variant = this.options.value;
      if (!/^\d+$/.test(variant)) { this.message('error', true); return; }
      this.button.disabled = true;
      this.button.textContent = this.strings.sending;
      this.status.hidden = true;
      this.form.setAttribute('aria-busy', 'true');
      const request = new AbortController();
      this.request = request;
      const timeout = setTimeout(() => request.abort(), 15000);
      try {
        const response = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(site), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2026-07-15', Accept: 'application/vnd.api+json' },
          credentials: 'omit',
          signal: request.signal,
          body: JSON.stringify({ data: {
            type: 'back-in-stock-subscription',
            attributes: { profile: { data: { type: 'profile', attributes: { email: this.email.value.trim() } } }, channels: ['EMAIL'] },
            relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant } } }
          } })
        });
        if (this.request !== request) return;
        if (response.status !== 202) {
          const result = await response.json().catch(() => ({}));
          if (this.request !== request) return;
          const invalidEmail = result.errors?.some(error => /email/i.test(error.detail || '') && error.status === '400');
          this.message(invalidEmail ? 'invalid_email' : 'error', true);
          return;
        }
        this.form.hidden = true;
        this.message('success', false);
      } catch {
        if (this.request === request) this.message('error', true);
      } finally {
        clearTimeout(timeout);
        if (this.request === request) {
          this.form.removeAttribute('aria-busy');
          this.button.disabled = false;
          this.button.textContent = this.label;
        }
      }
    }
  }
  customElements.define('cf-restock', RestockDialog);
})();
